import { FC, memo, useState } from 'react';
import { EventFlowBase } from './EventFlowBase';
import { GameAutocomplete } from './GameAutocomplete';
import { useCreateEventContext } from '../../../contexts/organizer/create-event/CreateEventContext';

export const SelectGame: FC = memo(function SelectGameUnmemoized() {
  const { setEvent } = useCreateEventContext();
  const [disabled, setDisabled] = useState<boolean>(true);
  return (
    <EventFlowBase
      title="Select Game"
      subtitle="Select the game your event will be associated with"
      nextPageKey="Select Event Type"
      continueDisabled={disabled}
      disableNav
      Content={
        <GameAutocomplete
          setGame={(gameId: string) => {
            setEvent((prev) => {
              return {
                ...prev,
                gameId,
              };
            });
            setDisabled(false);
          }}
        />
      }
    />
  );
});
